import { Component, Inject, Input, OnChanges, OnDestroy } from '@angular/core';

import { SportConfigToken } from '@config/sport.config';

import { Subscription, timer } from 'rxjs';

import { MatchListService } from '@services/match-list.service';
import { environment } from 'src/environments/environment';

import { MatchData } from '@interfaces/match-data.interface';
import { LangService } from '@services/lang.service';

import { ENTERLEAVE } from '@shared/animations/enter-leave.animation';

import { BaseComponent } from '../base.component';

@Component({
    selector: 'app-just-ended-matches',
    templateUrl: './just-ended-matches.component.html',
    animations: [ENTERLEAVE],

})
export class JustEndedMatchesComponent extends BaseComponent
    implements OnDestroy, OnChanges {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    public $data: MatchData[];

    private subscription: Subscription;

    private static close = false;

    public num: number = 5;

    public constructor(@Inject(SportConfigToken) public sportConfig: Record<string, any>,
        public matchList: MatchListService, protected lang: LangService) {
        super();
    }

    // public ngOnInit(): void {
    //     // this.subscription = timer(0, environment.leagueTableReloadTime || 15000).subscribe((): void => {
    //     //     this.matchList.getLastMatches(this.sportId,
    // this.lang.getLangSnapshot(), 5).subscribe((v: MatchData[]) => {
    //     //         this.$data = v;
    //     //     });
    //     // });
    // }

    public ngOnChanges(): void {
        this.ngOnDestroy();
        if (this.$data) {
            this.$data.splice(0);
        }
        this.subscription = timer(0, environment.matchListReloadTime).subscribe((): void => {
            this.load();
        });
    }

    public ngOnDestroy(): void {
        if (this.subscription instanceof Subscription) {
            this.subscription.unsubscribe();
        }
    }

    public trackById(index: number, item: Record<string, any>): number {
        return item.id;
    }

    public setNum(num: number): void {
        this.num = num;
        this.load();
    }

    public close(): void {
        JustEndedMatchesComponent.close = !JustEndedMatchesComponent.close;
    }

    get isClose(): boolean {
        return JustEndedMatchesComponent.close;
    }

    private load(): void {
        this.matchList.getLastMatches(this.sportId, this.lang.getLangSnapshot(),
            this.num).subscribe((v: MatchData[]) => {
            this.$data = v;
        });
    }
}
